import React from 'react';
import { Stack, Typography } from '@mui/material';
import { FaMotorcycle, FaMoneyBillWave, FaRegCreditCard } from 'react-icons/fa';

export default function LoanContracts({curLoanCredit, totalLoanCredit, curLoanInstallment, totalLoanInstallment}) {
  // Dữ liệu mẫu
  const data = [
    { icon: <FaMoneyBillWave />, label: 'Tín Chấp', current:curLoanCredit, total: totalLoanCredit },
    { icon: <FaRegCreditCard />, label: 'Trả Góp', current: curLoanInstallment, total: totalLoanInstallment },
  ];

  return (
    <Stack alignItems="center" sx={{ width: '100%', padding: 2 }}>
      {/* Tiêu đề */}
      <Stack direction="row" justifyContent="space-between" sx={{ width: '80%' }}>
        <Typography variant="h6" sx={{ flex: 1, textAlign: 'center', fontWeight: 'bold' }}>
          Số HĐ đang vay
        </Typography>
        <Typography variant="h6" sx={{ flex: 1, textAlign: 'center', fontWeight: 'bold' }}>
          Tổng số
        </Typography>
      </Stack>

      {/* Nội dung */}
      {data.map((item, index) => (
        <Stack
          key={index}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ width: '80%', paddingY: 1, borderBottom: '1px dotted #ddd' }}
        >
          {/* Biểu tượng và tên */}
          <Stack direction="row" alignItems="center" sx={{ flex: 1 }}>
            {item.icon}
            <Typography variant="body1" sx={{ marginLeft: 1 }}>
              {item.label}
            </Typography>
          </Stack>

          {/* Số hợp đồng đang vay */}
          <Typography
            variant="body1"
            color={item.current > 0 ? 'red' : 'text.secondary'}
            sx={{ flex: 1, textAlign: 'center', fontWeight: item.current > 0 ? 'bold' : 'normal' }}
          >
            {item.current}
          </Typography>

          {/* Tổng số */}
          <Typography variant="body1" color="text.secondary" sx={{ flex: 1, textAlign: 'center' }}>
            {item.total}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
}
